import Cookies from "js-cookie";
import { PetUnderwriterType } from "spot-types/entities/PetQuote";
import { BrandService } from "../BrandService";
import { useMemo } from "react";

const BRAND_DATA = BrandService.getCurrentBrandData();

export type QuoteAttributes = {
    quoteId?: string;
    cobrandId?: string;
    formId?: string;
    formStepId?: string;
    partnerCodeLowerCase?: string;
    quoteHasCats?: boolean;
    quoteHasDogs?: boolean;
    quoteHasIllnessCoverage?: boolean;
    quoteLocation?: string;
    quotePetCount?: number;
    quoteUnderwriter?: PetUnderwriterType;
    queryParamsStringLowerCase?: string;
    /** First name of the customer who saved the quote. Written by spot-quote-next. */
    firstName?: string;
    /** Ordered list of pet names in the saved quote. Written by spot-quote-next. */
    petNames?: string[];
    /** Gift-card provider the saved quote is eligible for, or undefined if none. Written by spot-quote-next. */
    giftCardProvider?: "VISA_VIRTUAL" | "SAMSCLUB";
};

export const useQuoteData = (): QuoteAttributes => {
    const quoteId = !!BRAND_DATA?.quoteIdCookieKey ? Cookies.get(BRAND_DATA.quoteIdCookieKey) : undefined;
    const quoteAttributes = !!BRAND_DATA?.quoteAttributesCookieKey ? Cookies.get(BRAND_DATA.quoteAttributesCookieKey) : undefined;

    const data = useMemo(() => {
        let parsedAttributes: QuoteAttributes | undefined;

        if (quoteAttributes) {
            try {
                parsedAttributes = JSON.parse(quoteAttributes);
            } catch {
                parsedAttributes = undefined;
            }
        }

        return {
            ...parsedAttributes,
            quotePetCount: Number(parsedAttributes?.quotePetCount ?? 0),
            quoteId
        };
    }, [quoteAttributes, quoteId]);

    return data;
};
